import { e as _typeof, _ as _slicedToArray, a as _objectSpread2, b as _defineProperty } from './_rollupPluginBabelHelpers-bd852068.js';
import { baseTheme } from './baseTheme.js';
import { useTheme } from './useTheme.js';
import { B as BREAKPOINTS_NAMES } from './scale-15569e54.js';

/**
 * Strict check on object type.
 */
var isObject = function isObject(item) {
  return _typeof(item) === 'object' && !Array.isArray(item) && item !== null;
};

/**
 * Calculate CSS Object from component props with `AllowMedia` type (user can pass object with breakpoints through prop). CSS property can be calculated based on multiple props.
 */
var useCSSProperty = function useCSSProperty(_ref) {
  var name = _ref.name,
    props = _ref.props,
    condition = _ref.condition,
    transform = _ref.transform;
  var _useTheme = useTheme(),
    layout = _useTheme.layout;
  var layoutTheme = layout || baseTheme.layout;
  var breakpoints = layoutTheme.breakpoints;
  if (condition !== undefined && !condition) return;
  var propsValues = Object.values(props);
  var isUndefined = propsValues.every(function (value) {
    return value === undefined;
  });
  if (isUndefined) return;
  var mediaProp = propsValues.find(function (value) {
    return isObject(value);
  });
  if (!mediaProp) return setValue(name, props, transform);
  return Object.keys(mediaProp).sort(function (a, b) {
    return BREAKPOINTS_NAMES.indexOf(a) - BREAKPOINTS_NAMES.indexOf(b);
  }).reduce(function (acc, bp) {
    var nameIndex = BREAKPOINTS_NAMES.indexOf(bp);
    var nextBp = nameIndex !== -1 && BREAKPOINTS_NAMES[nameIndex - 1];
    var breakpointProps = Object.fromEntries(Object.entries(props).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];
      return [key, !isObject(value) ? value : value[bp]];
    }));
    var rule = setValue(name, breakpointProps, transform);
    return _objectSpread2(_objectSpread2({}, acc), nextBp ? _defineProperty({}, "@media (max-width: ".concat(breakpoints[nextBp] - 1, "px)"), rule) : rule);
  }, {});
};
var setValue = function setValue(name, props, transform) {
  return _defineProperty({}, name, transform ? transform(props) : Object.values(props)[0]);
};

export { useCSSProperty as u };
